import { useContext, useState } from "react";
import useSWR from "swr";
import getBuyerAPIDomain from "../getBuyerAPIDomain";
import { SavedSearchesResponse } from "../SavedSearches/types";
import getSavedSearches from "../SavedSearches/api/getSavedSearches";
import { ErrorContext } from "../context/ErrorContext";
import { ParsedUrlQuery } from "querystring";
import { useAuth } from "@bca-auth0/bca-auth0-provider";

export const useGetSavedSearches = (
  queryString: ParsedUrlQuery,
  isToUseAuthZero: boolean
) => {
  const { accessToken } = useAuth(!isToUseAuthZero);

  const buyerAPIDomain = getBuyerAPIDomain(isToUseAuthZero);
  const errorContext = useContext(ErrorContext);

  const [isLoading, setIsloading] = useState<boolean>(true);

  const savedSearchResultsUrl = buyerAPIDomain
    ? new URL(`${buyerAPIDomain.href}/savedsearch/list`, buyerAPIDomain)
    : null;

  if (savedSearchResultsUrl && queryString) {
    Object.keys(queryString).map((queryName) =>
      savedSearchResultsUrl.searchParams.append(
        queryName,
        queryString[queryName] as string
      )
    );
  }

  const { data: savedSearchResults, mutate: mutateSearch } =
    useSWR<SavedSearchesResponse>(
      savedSearchResultsUrl && (accessToken || !isToUseAuthZero)
        ? [savedSearchResultsUrl.href, isToUseAuthZero, accessToken]
        : null,
      getSavedSearches,
      {
        revalidateOnFocus: false,
        shouldRetryOnError: false,
        onSuccess: () => {
          setIsloading(false);
        },
        onError: () => {
          setIsloading(false);
          errorContext?.dispatch({ type: "saved-searches" });
        },
      }
    );

  return {
    savedSearchResults,
    mutateSearch,
    isLoading,
  };
};
